import * as angular from "angular";
import template from "./entity-reporting-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig,
	EntityTypePermission
} from "./entityModalTabTypes";

export interface EntityReportingTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	permissions?: EntityTypePermission[];
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityReportingTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;
	public isReadonly = true;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const permission = this.permissions?.find(item => item.Code === this.typeConfig.Code);
		this.tab = {
			name: "Reporting",
			code: "REPORTING",
			isAvailable: permission?.Reporting !== undefined
				&& !permission.Reporting.IsDisabled
		};
		this.isReadonly = !this.securityService.isActionAllowed(
			globs.entityTypes.byType(this.typeConfig.Code).write
		);
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-reporting-tab", [])
	.component("entityReportingTab", {
		controller: EntityReportingTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			permissions: "<",
			put: "=",
			post: "="
		}
	})
	.name;
